<template>
    <div id="app" class="container">
        <router-view/>
    </div>
</template>
<style lang="stylus">

</style>
<script>
    export default {
        name: "App",

        metaInfo: {
            title: 'Small business offers',
            titleTemplate: '%s | VWFS Fleet',
            htmlAttrs: {
                lang: 'en'
            }
        },
    }
</script>

<style lang="stylus">
    #app
        padding-left 0
        padding-right 0

        .table.b-table > thead > tr > th[aria-sort]::before
            display: block;
            position absolute
            right 3px
            bottom .75rem
            width: .8em;
            font-size: 1.2rem;
            line-height: inherit;
            opacity: 0.4;
            content: "\2195";
            speak: none;
            cursor: pointer;

            @media(max-width 1199px)
                content ''

        .table.b-table > thead > tr > th[aria-sort][aria-sort="ascending"]::before
            opacity: 1;
            content: "\2193";

            @media(max-width 1199px)
                content ''

        .table.b-table > thead > tr > th[aria-sort][aria-sort="descending"]::before
            opacity: 1;
            content: "\2191";

            @media(max-width 1199px)
                content ''

        .cta-wrapper
            justify-content center
            margin-top 8px

            .button
                display flex
                text-align center
                justify-content center
                align-items center
                min-width 140px


                &:first-child
                    margin-right 3rem

        .slick-slider
            //margin 0 -15px
            .slick-track
                margin-left 0

        span
            &.info
                border 0
                border-radius 0

        .popover
            max-width 334px
            .popover-body
                font-family: "VWAGTheSansRegular", Arial, sans-serif;
                font-size 18px
                line-height 1.4
                padding 21px 32px
                max-width 334px
                p
                    margin-bottom 0

        .info
            width 2.2rem
            height 2.2rem
            font-size 1.6rem
            line-height 2.2rem
            transform translate(3px, -2px)

</style>